// Mock data for Santani's Portfolio

export const personalInfo = {
  name: "Santani",
  title: "Front-End Developer",
  tagline:
    "Building modern, animated interfaces with React & Next.js, supported by Laravel and SQL databases.",
  email: "santani423@gmail.com",
  location: "Indonesia",
  github: "https://github.com/santani423",
  linkedin: "https://www.linkedin.com/in/santani-1062b11b6/",
};

export const about = {
  summary:
    "I'm a Front-End Developer specializing in creating beautiful, performant web applications with modern frameworks. I focus on crafting intuitive user interfaces with smooth animations and interactions, while maintaining clean architecture and seamless integration with backend systems.",
  features: [
    {
      id: 1,
      title: "Modern Front-End",
      description:
        "Building scalable applications with React, Next.js, and modern JavaScript.",
      icon: "Code2",
    },
    {
      id: 2,
      title: "Motion & Interaction",
      description:
        "Creating delightful user experiences with Framer Motion and advanced CSS.",
      icon: "Sparkles",
    },
    {
      id: 3,
      title: "Backend APIs",
      description:
        "Developing robust REST APIs with Laravel and seamless frontend integration.",
      icon: "Server",
    },
    {
      id: 4,
      title: "Database Design",
      description:
        "Designing efficient database schemas with MySQL and PostgreSQL.",
      icon: "Database",
    },
  ],
};

export const skills = {
  frontend: [
    "React",
    "Next.js",
    "JavaScript",
    "TypeScript",
    "Tailwind CSS",
    "Framer Motion",
    "HTML5",
    "CSS3",
    "Responsive Design",
  ],
  backend: ["Laravel", "PHP", "REST APIs", "Authentication", "API Integration"],
  database: ["MySQL", "PostgreSQL", "Database Design", "Query Optimization"],
  tools: ["Git", "GitHub", "VS Code", "Figma", "npm/yarn", "Webpack"],
};

export const projects = [
  {
    id: 1,
    title: "Bank Sampah Management System",
    description:
      "Web-based waste bank management system that helps record customer waste deposits, manage savings balances, and generate transaction reports. Built with Laravel for the backend and Bootstrap for the responsive interface, using MySQL as the database.",
    tags: ["Laravel", "Bootstrap", "MySQL"],
    image: "https://santani.dev/project/img/berkahMitra.png",
    link: "https://berkahmitra.id/",
  },
  {
    id: 2,
    title: "RanselPro Landing Page",
    description:
      "A modern business landing page developed for RanselPro to showcase products and services with a clean and responsive design. The website focuses on clear call-to-action sections, product highlights, and optimized performance for marketing purposes.",
    tags: ["HTML", "CSS", "JavaScript", "React Js", "Responsive Design"],
    image: "https://santani.dev/project/img/ranselPro.png",
    link: "https://ranselpro.com/",
  },

  {
    id: 3,
    title: "Daffana Nusantara Travel Landing Page",
    description:
      "A travel agency landing page designed to promote tourism packages and destinations across Indonesia. The website features a responsive layout, destination highlights, service information, and clear call-to-action sections to help users easily explore and book travel packages.",
    tags: ["HTML", "CSS", "JavaScript", "Responsive Design"],
    image: "https://santani.dev/project/img/daffananusantara.png",
    link: "https://daffananusantara.com/",
  },

  {
    id: 4,
    title: "Talenta Muda Psychotest Platform",
    description:
      "An online psychotest platform developed for the Talenta Muda program to streamline candidate assessments. The system allows participants to complete psychological tests through structured forms, while enabling administrators to collect and manage responses efficiently.",
    tags: ["Laravel", "Bootstrap", "MySQL", "Form System"],
    image: "https://santani.dev/project/img/talentaMuda.png",
    link: "https://talenta-muda.id/",
  },
];

export const experience = [
  {
    id: 1,
    step: "01",
    title: "UI Design",
    description:
      "Crafting intuitive and beautiful user interfaces with modern design principles.",
  },
  {
    id: 2,
    step: "02",
    title: "Front-End Development",
    description:
      "Building responsive, performant applications with React and modern tooling.",
  },
  {
    id: 3,
    step: "03",
    title: "API Integration",
    description:
      "Connecting frontend with backend services, ensuring seamless data flow.",
  },
  {
    id: 4,
    step: "04",
    title: "Database Optimization",
    description:
      "Designing efficient database structures and optimizing query performance.",
  },
];

export const contact = {
  email: "santani@example.com",
  location: "Indonesia",
  availability: "Available for freelance projects",
};
